import React, {useEffect, useMemo, useState} from 'react';
import {useParams, Link, useNavigate} from 'react-router-dom';
import axios from 'axios';
import Header from "../Header/Header";
import './RentalDetails.css'
import {FaEdit} from 'react-icons/fa';

import GetDaysCount, {getDeliveryPrice, getReturnRental, normalizePhoneNumber} from "../../utils/utils";
import {HOST} from "../../utils/vars";
import Loading from "../Loading/Loading";
import {
  Courier,
  Delivery,
  IData,
  IDelivery,
  IDeliveryOption,
  IRental,
  RentalEditFormState
} from "../RentalList/RentalInterfaces";
import TimedAlert from "../Alerts/TimedAlert";
import DeliveryDialog from "../DialogModal/DeliveryDialog";
import RentalForm from "../RentalForm/RentalForm";
import {useAuth} from "../../context/AuthContext";
import {RouteMap} from "../Routes/Routes";



const RentalDetails = () => {
  const navigate = useNavigate();
  const {user} = useAuth();
  const {id} = useParams();
  const [updating, setUpdating] = useState<boolean>(false);

  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);
  const [dialogAwaiting, setDialogAwaiting] = useState<{
    resolve: (data: any) => void;
  } | null>(null);

  const [dataDelivery, setDataDelivery] = useState<any>();
  const [showAlert, setShowAlert] = useState(false);
  const [alertText, setAlertText] = useState('');
  const [rental, setRental] = useState<IRental | null>(null);
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [isEditingDelivery, setIsEditingDelivery] = useState<boolean>(false);
  const [isEditingReturnDelivery, setIsEditingReturnDelivery] = useState<boolean>(false);

  const [isEditingRental, setIsEditingRental] = useState<boolean>(false);
  const [editedFormData, setEditedFormData] = useState({
    productId: '',
    extras: [] as string[],
    deliveries: [{type: 'delivery', address: '', optionId: '', comment: ''}] as Delivery[],
    startDate: new Date().toISOString().split('T')[0],
    status: 'создан',
  });

  const [editableStatus, setEditableStatus] = useState<string>('');
  const [couriers, setCouriers] = useState<Courier[]>([]);
  // const [editableDeliveries, setEditableDeliveries] = useState(rental.deliveries || []);

  const [deliveryOptions, setDeliveryOptions] = useState<IDeliveryOption[]>([]);
  const [newReturnDelivery, setNewReturnDelivery] = useState<IDelivery & { initialized?: boolean }>({
    type: 'return',
    address: '',
    optionId: '',
    customer_name: '',
    customerName: '',
    phone: '',
    comment: '',
    price: 0,
    initialized: false
  });

  const [mainComment, setMainComment] = useState('');
  const [routePoints, setRoutePoints] = useState([]);

  const deliveryPrice = useMemo(() => getDeliveryPrice(rental), [rental]);
  const returnRental = useMemo(() => getReturnRental(rental), [rental]);

  axios.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });

  useEffect(() => {
    axios.get(HOST + '/api/v1/delivery-options').then(res => setDeliveryOptions(res.data));
    axios.get(HOST + '/api/v1/couriers').then(res => setCouriers(res.data));
  }, [])

  useEffect(() => {
    axios.get(`${HOST}/api/v1/rentals/${id}`).then(res => {
      setRental(res.data);
      setEditableStatus(res.data.status);
    });
  }, [id]);

  useEffect(() => {
    axios.get(`${HOST}/api/v1/track/${id}`).then(res => {
      setRoutePoints(res.data);
    })
  }, [rental]);

  useEffect(() => {
    if (
      editableStatus === 'обратная доставка' &&
      rental &&
      !rental.end_date
    ) {
      // const today = new Date(Date.now().toLocaleString('ru-RU')).toString();
      const today = new Date();
      const formatted = today.toISOString().split('T')[0]; // yyyy-mm-dd
      setRental({...rental, end_date: formatted});
      setMainComment(rental?.comment || '');
    }
  }, [editableStatus, rental]);

  useEffect(() => {
    if (
      rental &&
      rental.deliveries?.length > 0 &&
      !newReturnDelivery.initialized
    ) {
      const base = rental.deliveries[0];
      setNewReturnDelivery(prev => ({
        ...prev,
        address: base.address || '',
        customer_name: base.customer_name || '',
        phone: base.phone || '',
        initialized: true
      }));
    }
  }, [rental, newReturnDelivery]);

  useEffect(() => {
    setMainComment(rental?.comment || '');
  }, [rental]);

  // --------

  const handleFormChange = (updatedForm: RentalEditFormState) => {
    setEditedFormData(updatedForm);
  };

  const handleStatusChange = async (newStatus: string) => {
    if (newStatus === 'аренда' || newStatus === 'закрыт') {
      // const result = await openDeliveryDialog();
      //
      // if (result?.notFilled) {
      //   setIsEditing(false);
      //   triggerAlert("Заповнiть пробiг та грошi")
      //   return;
      // }

      // performMainLogic(result, newStatus);
      performMainLogic();
    } else {
      if (hasInvalidDelivery(newReturnDelivery)) {
        setAlertText('Заповнiть зворотню доставку');
        setShowAlert(true);
        return;
      }
      performMainLogic();
    }
  };

  const openDeliveryDialog = () => {
    return new Promise<{ inp1?: number; inp2?: number; notFilled?: boolean }>((resolve) => {
      setDialogAwaiting({resolve});
      setIsDialogOpen(true);
    });
  };

  const hasInvalidDelivery = (delivery: IDelivery) => {
    return (
      !delivery.courier_name ||
      !delivery.optionId ||
      ((delivery.optionId !== '9') && !delivery.address) ||
      !delivery.customer_name ||
      !delivery.phone
    );
  };

  const performMainLogic = (deliveryData?: {
    inp1?: number;
    inp2?: number;
    inp3?: number;
    inp4?: number
  }, newStatus?: string) => {
    // let delivery: number = 2;
    // if (deliveryData) {
    //   if (newStatus === 'аренда') {
    //     delivery = 0;
    //   }
    //   if (newStatus === 'закрыт') {
    //     delivery = 1;
    //   }
    //
    //   try {
    //     // console.log("++++++ ", delivery)
    //     // console.log("++++++++++ ", rental?.deliveries[delivery]?.id, rental?.deliveries[delivery])
    //     axios.post(`${HOST}/api/v1/rentals/distance`, {
    //       "all_distance": deliveryData.inp1,
    //       "out_of_town": deliveryData.inp2 || 0,
    //       "delivery_id": rental?.deliveries[delivery].id,
    //       "rental_id": rental?.id
    //     }).then(res => {
    //       console.log(res.data);
    //     })
    //
    //     axios.post(`${HOST}/api/v1/rentals/payments`, {
    //       "delivery_id": rental?.deliveries[delivery].id,
    //       "rental_id": rental?.id,
    //       "payment_type": 1,
    //       "by_card": deliveryData.inp4 || 0,
    //       "by_cash": deliveryData.inp3 || 0
    //     }).then(res => {
    //       console.log(res.data);
    //     })
    //   } catch (e) {
    //     console.log("update distance and delivery error: ", e);
    //   }
    // }

    setUpdating(true);
    if (editableStatus === 'обратная доставка') {

      axios.post(`${HOST}/api/v1/delivery`, {
        rentalId: rental?.id,
        delivery: newReturnDelivery
      }).then(res => {
        console.log("New delivery save: ", res.data);
      }).catch(res => {
        setAlertText('Зворотня доставка вже додана. Оновiть сторiнку');
        setShowAlert(true);
        console.log(res);
        // navigate(`/rental/${rental?.id}`);
        setIsEditing(false);
        return;
      })
      if (rental) {
        setRental({
          ...rental,
          deliveries: [...(rental.deliveries || []), newReturnDelivery]
        });
      }
    }

    let endDate = '';
    if (editableStatus === 'обратная доставка') {
      endDate = rental?.end_date || '';
    }
    axios.post(`${HOST}/api/v1/rentals/update/${rental?.id}`, {
      status: editableStatus,
      end_date: endDate
    }).then(res => {
      if (rental) {
        setRental({...rental, status: editableStatus})
      }
      setIsEditing(false);
      // navigate(`/rental/${rental?.id}`)
    });
    setUpdating(false);
  };

  // ----------

  const handleSaveComment = () => {
    if (!rental?.id) {
      return;
    }
    axios.post(`${HOST}/api/v1/rentals/update-comment`, {
      id: rental?.id,
      comment: mainComment || ''
    }).then(res => {
      triggerAlert('Коментар збережено')
    })
  }

  const triggerAlert = (message: string) => {
    setAlertText(message);
    setShowAlert(true);
  };

  const handleSaveDeliveryChanges = (dataDelivery: any) => {

    if (editableStatus === 'аренда') {
      setIsDialogOpen(true);

      if (dataDelivery && dataDelivery?.notFilled) {
        setAlertText('Статус не оновлений. Заповнiть кiлометраж');
        setShowAlert(true);
        setIsEditing(false)
        return;
      } else {
        setIsEditing(false)
      }
    }


    // if (editableStatus === 'обратная доставка') {
    //   console.log("handleSave обратная доставка");
    //   // setDeliveryType("return")
    // }
  };

  const getDeliveryOptions = (value: number): IDeliveryOption | undefined => {
    return deliveryOptions.find((item: IDeliveryOption) => Number(item.id) === Number(value));
  };

  const handleBackButton = () => {
    if (isEditingRental) setIsEditingRental(false);
    if (!isEditingRental) navigate('/');
  };

  const handleSaveEditingRental = async () => {
    try {
      const response = await axios.patch(`${HOST}/api/v1/rentals/update/${rental?.id}`, editedFormData);
      setIsEditingRental(false);
    } catch (e) {
      console.error(e);
      // @ts-ignore
      setAlertText(`Не вдалося оновити оренду. ${e?.message}`)
      setShowAlert(true);
    }
  };

  const calculateDistance = (value: number) => {
    console.log("Distance: ", value);
  }

  const statusOptions = ['создан', 'аренда', 'обратная доставка', 'закрыт', 'отменен'];

  if (!rental || updating) return (
    <Loading/>
  );

  // @ts-ignore
  return (
    <>
      <Header/>

      <div className="rental-details-container">
        <div className="rental-section">

          {/* save and update buttons */}
          <div className="button-group mt-3 text-end">
            {isEditing ? (
              <>
                <button
                  className="btn btn-success me-2"
                  onClick={() => handleStatusChange(editableStatus)}>💾 Зберегти
                </button>
                <button className="btn btn-secondary" onClick={() => setIsEditing(false)}>Скасувати</button>
              </>
            ) : (
              <>
                {rental.status !== 'закрыт' && !isEditingRental
                  && (
                    <>
                      {user.role === 'admin' && (
                        <button
                          className="btn btn-light me-2"
                          onClick={() => setIsEditingRental(true)}
                        >
                          Редагувати
                        </button>
                      )}
                      <button
                        className="btn btn-primary me-2"
                        onClick={() => setIsEditing(true
                        )}>
                        Оновити статус
                      </button>
                    </>
                  )
                }
                {isEditingRental && (
                  <button
                    className="btn btn-success me-2"
                    onClick={() => handleSaveEditingRental()}
                  >
                    Зберегти
                  </button>
                )}
                <button
                  className="btn btn-light me-2"
                  onClick={() => handleBackButton()}
                >
                  ← Назад
                </button>
              </>
            )}
          </div>

        </div>

        <h2>Аренда #{rental.id}</h2>

        {isEditingRental ? (
          <RentalForm rental={rental} onChange={handleFormChange}/>
        ) : (
          <>
            {/* rental status section */}
            <div className="rental-section">
              <p><strong>Статус:</strong></p>
              {isEditing ? (
                <select
                  value={editableStatus}
                  onChange={e => setEditableStatus(e.target.value)}
                  className="form-select"
                >
                  {statusOptions.map(status => (
                    <option key={status} value={status}>
                      {status}
                    </option>
                  ))}
                </select>
              ) : (
                <p>{rental.status}</p>
              )}
            </div>

            {/* rental period section */}
            <div className="rental-section">
              <p><strong>Період:</strong> с {new Date(rental.start_date).toLocaleDateString('ru-RU')} {rental.end_date ?
                `по ${new Date(rental.end_date).toLocaleDateString('ru-RU')}` : ''}</p>

              {rental.end_date && (
                <p><strong>Кількість днів:</strong> {GetDaysCount(rental.start_date, rental.end_date)}</p>
              )}

              {(isEditing && editableStatus === 'обратная доставка' && editableStatus !== rental.status) && (
                <div className="col-md-6">
                  <label className="form-label">Дата закінчення</label>
                  <input
                    type="date"
                    className="form-control"
                    value={rental.end_date || new Date().toISOString().split('T')[0]}
                    onChange={e => setRental({...rental, end_date: e.target.value})}
                  />
                </div>
              )}
            </div>

            {/* rental product type */}
            <div className="rental-section">
              <h4>Товар</h4>
              <p>{rental.product_name} — {rental.price_per_day} грн/день</p>
              <p><strong>Залог:</strong> {rental.deposit} грн</p>
            </div>
            products

            {/* rental additional products section */}
            {rental.extras?.length > 0 && (
              <div className="rental-section">
                <h4>Доп. товары</h4>
                <ul className="extras-list">
                  {rental.extras.map((extra: any) => (
                    <li key={extra.id}>
                      <strong>{extra.name}</strong> — {extra.price} грн ({Number(extra.extra_price)}грн/доба)
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/*  ================================== deliveries section ===================================================*/}
            {/* rental deliveries section*/}
            <div className="rental-section">

              <div className="d-flex justify-content-between align-items-center">
                <h4>Доставка</h4>
              </div>

              {rental.deliveries?.map((delivery: any, idx: number) => (
                <div key={idx} className="delivery-block">
                  <span><strong>{delivery.type === 'delivery' ? 'Доставка' : 'Обратная доставка'}</strong></span>
                  <br/>
                  <p>
                    <strong>Тип:</strong> {delivery.name} — {delivery.price} грн
                    {delivery.is_fixed ? '' : ` + ${delivery.extra_price}грн за км`}
                  </p>
                  <p><strong>Курьер:</strong> {delivery.courier_name}</p>
                  <p><strong>Адрес:</strong> {delivery.address}</p>
                  <p><strong>Имя:</strong> {delivery.customer_name}</p>
                  <p><strong>Телефон:</strong> <a
                    href={`tel:${normalizePhoneNumber(delivery.phone)}`}>{normalizePhoneNumber(delivery.phone)}</a></p>
                  <p><strong>Комментарий:</strong> {delivery.comment}</p>
                </div>
              ))}

              {(isEditing && editableStatus === 'обратная доставка' && editableStatus !== rental.status) && (
                <div className="rental-section mt-3">
                  <h5>Добавить обратную доставку</h5>
                  <div className="mb-2">
                    <label className="form-label">Курьер</label>
                    <select
                      className="form-select mb-2"
                      value={newReturnDelivery.courier_name || ''}
                      onChange={e => {
                        setNewReturnDelivery({...newReturnDelivery, courier_name: e.target.value});
                      }}
                    >
                      <option value="">Выберите курьера</option>
                      {couriers.map(courier => (
                        <option key={courier.username} value={courier.username}>
                          {courier.username}
                        </option>
                      ))}
                    </select>

                    <label>Тип доставки:</label>
                    <select
                      className="form-select"
                      value={newReturnDelivery.optionId}
                      onChange={e => {
                        const deliveryOptions = getDeliveryOptions(Number(e.target.value));
                        setNewReturnDelivery({
                          ...newReturnDelivery,
                          optionId: e.target.value
                        })
                      }
                      }
                    >
                      <option value="">Выберите опцию</option>
                      {deliveryOptions.map(option => (
                        <option key={option.id} value={option.id}>
                          {option.name} — {option.price} грн
                        </option>
                      ))}
                    </select>
                  </div>

                  <label>Адреса:</label>
                  <input
                    type="text"
                    className="form-control"
                    disabled={newReturnDelivery.optionId === '9'}
                    value={newReturnDelivery.address}
                    onChange={e => setNewReturnDelivery({...newReturnDelivery, address: e.target.value})}
                  />

                  <label className="form-label">Имя</label>
                  <input
                    type="text"
                    className="form-control mb-2"
                    placeholder="Імʼя"
                    value={newReturnDelivery.customer_name}
                    onChange={e => setNewReturnDelivery({...newReturnDelivery, customer_name: e.target.value})}
                  />

                  <label className="form-label">Телефон</label>
                  <input
                    type="tel"
                    className="form-control mb-2"
                    placeholder="Телефон"
                    value={newReturnDelivery.phone}
                    onChange={e => setNewReturnDelivery({...newReturnDelivery, phone: e.target.value})}
                  />

                  <div className="mb-2">
                    <label>Коментар:</label>
                    <textarea
                      className="form-control"
                      value={newReturnDelivery.comment}
                      onChange={e => setNewReturnDelivery({...newReturnDelivery, comment: e.target.value})}
                    />
                  </div>
                </div>
              )}

              <div>
                <RouteMap points={routePoints} onDistanceCalculated={calculateDistance} />
              </div>
            </div>
            {/*  ================================== end deliveries section =============================================*/}

            {/* rental comment */}
            {(!isEditing && !isEditingRental) && (
              <div className="rental-section">
                <div className="mb-2">
                  <label>Коментар:</label>
                  <textarea
                    className="form-control"
                    value={mainComment}
                    onChange={(e) => setMainComment(e.target.value)}
                    rows={6}
                  />
                </div>
                <div className="button-group mt-3 text-end">
                  <button className="btn btn-success me-2" onClick={handleSaveComment}>Зберегти коментар</button>
                </div>
              </div>
            )}


            {/* TODO: uncomment*/}
            {/* rental prices */}
            <div className="rental-section">
              <b>Сумма:</b> {deliveryPrice.sum}
              <br/>
              {rental.status === 'обратная доставка' && (
                <div>
                  <b>Остаток: </b> {returnRental} грн
                </div>
              )}
            </div>
          </>
        )
        }

        {/* save and update buttons */}
        <div className="button-group mt-3 text-end">
          {isEditing ? (
            <>
              <button
                className="btn btn-success me-2"
                onClick={() => handleStatusChange(editableStatus)}>💾 Зберегти
              </button>
              <button className="btn btn-secondary" onClick={() => setIsEditing(false)}>Скасувати</button>
            </>
          ) : (
            <>
              {rental.status !== 'закрыт' && !isEditingRental
                && (
                  <>
                    {user.role === 'admin' && (
                      <button
                        className="btn btn-light me-2"
                        onClick={() => setIsEditingRental(true)}
                      >
                        Редагувати
                      </button>
                    )}
                    <button
                      className="btn btn-primary me-2"
                      onClick={() => setIsEditing(true
                      )}>
                      Оновити статус
                    </button>
                  </>
                )
              }
              {isEditingRental && (
                <button
                  className="btn btn-success me-2"
                  onClick={() => handleSaveEditingRental()}
                >
                  Зберегти
                </button>
              )}
              <button
                className="btn btn-light me-2"
                onClick={() => handleBackButton()}
              >
                ← Назад
              </button>
            </>
          )}
        </div>
      </div>

      <TimedAlert
        text={alertText}
        type="success"          // 'danger', 'info', 'warning', 'primary'
        show={showAlert}
        onClose={() => setShowAlert(false)}
        duration={5000}
      />

      <DeliveryDialog
        isOpen={isDialogOpen}
        title1="Кiлометрiв всього"
        title2="Кiлометрiв за мiсто"
        title3="Готiвкою"
        title4="Картка"
        onClose={() => setIsDialogOpen(false)}
        onConfirm={(data) => {
          dialogAwaiting?.resolve(data);
          setIsDialogOpen(false);
          setDialogAwaiting(null);
        }}
      />
    </>
  );
};

export default RentalDetails;